import React from "react"
import { createStyles } from "@design-system/core"
import { useInteractive, InteractiveContext } from "@design-system/interactive"
import { ViewLink } from "@design-system/link"

import { InteractiveViewProps, InteractiveStyles } from "./types"

const defaultInteractiveStyles: InteractiveStyles = createStyles((theme) => ({
  hover: {
    backgroundColor: theme.colors.gray050,
  },
  pressed: {
    backgroundColor: theme.colors.gray050,
  },
  focused: {
    backgroundColor: theme.colors.gray050,
  },
  transition: {
    transitionProperty: "background-color",
    transitionDuration: "0.2s",
  },
}))

const styles = createStyles({
  disabled: {
    opacity: 0.5,
  },
})

export function InteractiveView(props: InteractiveViewProps) {
  const { href, children, style, onClick, ...otherProps } = props

  const {
    isDisabled,
    isHovered,
    isPressed,
    isFocused,
    ...interactiveProps
  } = useInteractive(otherProps)

  const interactiveStyles = {
    ...defaultInteractiveStyles,
    ...props.interactiveStyles,
  }

  const content =
    typeof children === "function"
      ? children({
          isFocused,
          isHovered,
          isPressed,
        })
      : children

  return (
    <ViewLink
      {...interactiveProps}
      href={href}
      onClick={onClick}
      style={[
        interactiveStyles.transition,
        isHovered && interactiveStyles.hover,
        isPressed && interactiveStyles.pressed,
        isFocused && interactiveStyles.focused,
        isDisabled && styles.disabled,
        style,
      ]}
    >
      <InteractiveContext.Provider
        value={{
          isDisabled,
          isHovered,
          isPressed,
          isFocused,
        }}
      >
        {content}
      </InteractiveContext.Provider>
    </ViewLink>
  )
}
